/* ============================================================
   BEZET — галерея образу.

   <look-gallery> синхронізує доріжку кадрів зі стрілками, крапками
   й лічильником. Працює для будь-якої кількості кадрів; якщо кадр
   один, керування взагалі не виводиться (це вирішує Liquid).
   ============================================================ */

class LookGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-look-track]');
    if (!this.track) return;

    this.count = this.querySelector('[data-look-count]');
    this.dots = Array.from(this.querySelectorAll('[data-look-dot]'));
    this.navs = Array.from(this.querySelectorAll('[data-look-nav]'));
    this.slides = this.track.children.length;
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.navs.forEach((b) => {
      b.addEventListener('click', () => this.goTo(this.index + Number(b.dataset.lookNav)));
    });
    this.dots.forEach((d) => {
      d.addEventListener('click', () => this.goTo(Number(d.dataset.lookDot)));
    });

    this.render = this.render.bind(this);
    this.track.addEventListener('scroll', this.render, { passive: true });
    window.addEventListener('resize', this.render);
    this.render();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.render);
  }

  get index() {
    if (!this.track.clientWidth) return 0;
    return Math.min(Math.round(this.track.scrollLeft / this.track.clientWidth), this.slides - 1);
  }

  goTo(index) {
    const target = Math.max(0, Math.min(index, this.slides - 1));
    this.track.scrollTo({
      left: target * this.track.clientWidth,
      behavior: this.reduce ? 'auto' : 'smooth',
    });
  }

  render() {
    const i = this.index;
    if (this.count) this.count.textContent = `${i + 1} / ${this.slides}`;
    this.dots.forEach((d, n) => d.setAttribute('aria-current', String(n === i)));
    this.navs.forEach((b) => {
      const dir = Number(b.dataset.lookNav);
      b.disabled = (dir < 0 && i === 0) || (dir > 0 && i === this.slides - 1);
    });
  }
}

customElements.define('look-gallery', LookGallery);
